export const DATA_KEYS = {
  field1: "props.title",
  dimension1: "props.dimension1",
  dimension2: "props.dimension2",
  dimension1CustomRanges: "props.dimension1CustomRanges",
  dimension2CustomRanges: "props.dimension2CustomRanges",
  dimension1NumberOfBuckets: "props.dimension1NumberOfBuckets",
  dimension2NumberOfBuckets: "props.dimension2NumberOfBuckets",
  dimension1BucketSize: "props.dimension1BucketSize",
  dimension2BucketSize: "props.dimension2BucketSize",
  dimension1NumberFieldRepresentation: "props.dimension1NumberFieldRepresentation",
  dimension2NumberFieldRepresentation: "props.dimension2NumberFieldRepresentation",
  dimension1HistogramBucketMode: "props.dimension1HistogramBucketMode",
  dimension2HistogramBucketMode: "props.dimension2HistogramBucketMode",
  hiddenDim1Datapoints: "props.hiddenDim1Datapoints",
  hiddenDim2Datapoints: "props.hiddenDim2Datapoints",
  dim1VisibilityPreset: "props.dim1VisibilityPreset",
  dim2VisibilityPreset: "props.dim2VisibilityPreset",
  dim1VisibilityN: "props.dim1VisibilityN",
  dim2VisibilityN: "props.dim2VisibilityN",
  breakdownDisplayType: "props.breakdownDisplayType",
  displayMode: "props.displayMode",
  // Same prop names as the pie chart's combine-segments control (identical
  // meaning: keep N, collapse the rest into "Others"), so the setting survives
  // a switch between the two widget types.
  combineSegments: "props.combineSegments",
  numberOfSegments: "props.numberOfSegments",
  sortBars: "props.sortBars",
  sortGroups: "props.sortGroups",
  groupsFollowFirst: "props.groupsFollowFirst",
  hideZeroValues: "props.hideZeroValues",
};
